import React, { Component } from 'react';
import { FormGroup, Label, Col, Input, Button, Form, Alert } from 'reactstrap';
import { SiteTitle } from "./SiteTitle";
import { api_url } from "./globalFunction/global_string";
import Swal from 'sweetalert2';


export class FromChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      temporaryPassword: '',
      newPassword: '',
      confirmPassword: '',
      code: '',
      success: false,
    };
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }
  checkPasswordStrength = () => {
    const password = this.state.newPassword;
    let message = '';

    if (password.length < 8) {
      message += '密碼至少需要8個字符。';
    }
    if (!/\d/.test(password)) {
      message += '必須包含至少一個數字。';
    }
    if (!/[a-zA-Z]/.test(password)) {
      message += '必須包含至少一個英文字母。';
    }
    if (!/[\W_]/.test(password)) {
      message += '必須包含至少一個特殊符號。';
    }
    this.setState({ passwordMessage: message });
  };
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value }, () => {
      if (name === 'newPassword') {
        this.checkPasswordStrength();
      }
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.state.newPassword !== this.state.confirmPassword) {
      Swal.fire({
        icon: 'error',
        title: '【密碼必須一樣】',
        text: '新密碼和確認密碼必須一樣'
      });
      return;
    }

    let apiUrl = api_url + '/api/Auth/ResetPassword';
    const formData = new FormData();
    formData.append("Password", this.state.newPassword);
    formData.append("confirmPassword", this.state.confirmPassword);
    formData.append("verificationCode", this.state.code);
    fetch(apiUrl,
      {
        method: "POST",
        body: formData
      })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          console.error('Error parsing JSON:', error);
          throw error
        };
      })
      .then(data => {
        let arr_status = [String(data.statusCode), data.row, data.detail]
        switch (arr_status[0]) {
          case "200":
            Swal.fire({
              icon: 'success',
              title: '【修改成功】',
              text: '恭喜'
            });
            this.setState({
              temporaryPassword: '',
              newPassword: '',
              confirmPassword: '',
              code: '',
              isRecaptchaVerified: false,
              success: true
            });
            setTimeout(() => {
              window.location.href = 'https://va.nycu.edu.tw/login';
            }, 2000);
            break;
          case "400":
            Swal.fire({
              icon: 'error',
              title: `${data.row}`,
              text: 'sorry'
            });
            break;
          case "500":
            window.location.href = '404'
            break;
          default:
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  render() {
    return (
      <div className="container mt-5">
        <SiteTitle />
        <h1 id="tableLabel" className='mb-3 text-left'>修改密碼</h1>
        <div className="card p-5">
          <Form onSubmit={this.handleSubmit}>
            <FormGroup row className="mb-3">
              <Label for="newPassword" sm={2} className="text-right">新密碼</Label>
              <Col sm={10}>
                <Input
                  type="password"
                  name="newPassword"
                  placeholder=""
                  value={this.state.newPassword}
                  onChange={this.handleChange}
                />
                <div className="text-danger">
                  {this.state.passwordMessage}
                </div>
              </Col>
            </FormGroup>

            <FormGroup row className="mb-3">
              <Label for="newPassword" sm={2} className="text-right">確認密碼</Label>
              <Col sm={10}>
                <Input type="password" name="confirmPassword" placeholder="" value={this.state.confirmPassword} onChange={this.handleChange} />
              </Col>
            </FormGroup>
            <FormGroup row className="mb-3">
              <Label for="code" sm={2} className="text-right">驗證碼</Label>
              <Col sm={10}>
                <Input
                  type="text"
                  name="code"
                  maxLength="10"
                  placeholder=""
                  value={this.state.code}
                  onChange={this.handleChange}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Col sm={{ size: 10, offset: 2 }}>
                <Button color="primary" type="submit">修改</Button>
              </Col>
            </FormGroup>
            {this.state.success && <Alert color="success">修改成功！即將轉到登入頁面...</Alert>}
          </Form>
        </div>
      </div>
    );
  }
}
